var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-title"},_vm._l((_vm.titleArr),function(item,index){return _c('a',{key:index,staticClass:"item",staticStyle:{"cursor":"default"}},[_c('p',[_vm._v(_vm._s(item))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }